import Vue from "vue";
import { assign } from 'lodash'

export const state = Vue.observable({
  updateData: false,
  config: {},
  nivel_aprobacion: null,
  diasASolicitar: '',
  diasASolicitarValid: false,
  dateRangeArray: [],
  request: {
    fechaDesde: '',
    fechaReingreso: '',
    medioDia: false,
    holiday_types:[],
    documents: [],
    observaciones: '',
    periodoLiq: '',
    francos: [],
    hoursRange: ''
  },
  basicStateRequest: {
    fechaDesde: '',
    fechaReingreso: '',
    medioDia: false,
    documents: [],
    observaciones: '',
    periodoLiq: '',
    francos: [],
    hoursRange: ''
  },
  uploadFilesMetaData: {}
});

export const mutations = {
  updateHistory: status => {
    state.updateData = status
  },
  setConfig: value => {
    state.config = value
  },
  setUploadFilesMetaData: value => {
    state.uploadFilesMetaData = value
  },
  cleanConfig: () => {
    state.config = {}
  },
  cleanUploadFilesMetaData: () => {
    state.uploadFilesMetaData = {}
  },
  cleanFrancos: () => {
    state.request.francos = []
  },
  setDiasASolicitar: value => {
    state.diasASolicitar = value
  },
  setDiasASolicitarValid: value => {
    state.diasASolicitarValid = value
  },
  setDateRangeArray: rangeArray => {
    state.dateRangeArray = rangeArray
  },
  addParamToRequest: (value) => {
    //assign(state.request, value)
    const { request } = state
    assign(request, value)
    state.request = request
  },
  cleanRequest: () => {
    state.diasASolicitar = ''
    state.request = {...state.basicStateRequest}
  },
  setNivelAprobacion: value => {
    state.nivel_aprobacion = value
  }
}